const NIRKANA_WHATSAPP_NUMBER = "919080924318";

/**
 * Opens a pre-filled WhatsApp chat to Nirkana's number in a new tab.
 *
 * Important limitation: this cannot silently "send" a message on the
 * customer's behalf — no static website can do that without the paid,
 * server-side WhatsApp Business API. What this does is open the chat
 * with the message already typed in, so the customer only has to tap
 * Send. Must be called synchronously inside the click/submit handler
 * (before any `await`), or browsers will block it as a popup.
 */
export const openNirkanaWhatsApp = (message) => {
  const encoded = encodeURIComponent(message);
  window.open(`https://wa.me/${NIRKANA_WHATSAPP_NUMBER}?text=${encoded}`, "_blank", "noopener,noreferrer");
};

export default openNirkanaWhatsApp;
